import { Users, CheckCircle2, AlertTriangle, Lock } from "lucide-react";

const STATE_STYLE = {
  UNDER_MINIMUM: {
    box: "bg-amber-950/40 border-amber-500/50 text-amber-300",
    bar: "bg-amber-500",
    Icon: AlertTriangle,
  },
  ELIGIBLE: {
    box: "bg-emerald-950/40 border-emerald-500/50 text-emerald-300",
    bar: "bg-emerald-500",
    Icon: CheckCircle2,
  },
  FULL: {
    box: "bg-[#140f02]/40 border-[#E5B31E]/50 text-[#F0C72A]",
    bar: "bg-[#E5B31E]",
    Icon: Lock,
  },
};

export function RosterCounter({ roster }) {
  if (!roster) return null;
  const s = STATE_STYLE[roster.state] || STATE_STYLE.UNDER_MINIMUM;
  const pct = Math.min(100, (roster.count / roster.max) * 100);
  const { Icon } = s;
  return (
    <div
      data-testid="roster-counter-status"
      data-roster-state={roster.state}
      className={`rounded-xl border p-4 ${s.box}`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 font-mono text-xs font-bold uppercase tracking-wider">
          <Icon className="w-4 h-4" />
          {roster.label}
        </div>
        <div className="flex items-center gap-1.5 font-heading text-2xl font-extrabold tabular-nums">
          <Users className="w-5 h-5 opacity-70" />
          {roster.count}
          <span className="text-sm opacity-50">/ {roster.max}</span>
        </div>
      </div>
      <div className="h-2 w-full bg-slate-800 rounded-full overflow-hidden mt-3 relative">
        <div
          className={`h-full ${s.bar} rounded-full`}
          style={{ width: `${pct}%`, transition: "width 0.4s ease" }}
        />
        <div
          className="absolute top-0 bottom-0 w-px bg-white/40"
          style={{ left: `${(roster.min / roster.max) * 100}%` }}
          title={`Minimum ${roster.min}`}
        />
      </div>
    </div>
  );
}
